import { PageShell } from './PageShell';
import { Skeleton } from './Skeleton';

export function RouteSkeleton(): JSX.Element {
  return (
    <PageShell
      title={<h1 className="text-2xl font-bold tracking-tight text-brand-white">Capstone Engineering</h1>}
      headerAside={null}
    >
      <div aria-busy="true" aria-label="Loading section" className="flex flex-col gap-4 py-6">
        <Skeleton className="h-6 w-40" />
        <Skeleton className="h-4 w-64" />
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="rounded-xl bg-brand-steel p-4 ring-1 ring-brand-steel">
              <Skeleton className="h-4 w-1/3" />
              <Skeleton className="mt-3 h-8 w-2/3" />
            </div>
          ))}
        </div>
      </div>
    </PageShell>
  );
}
